(() => {
  const WORKER = "https://order.fashionprice.co.za";
  const SESSION_KEY = "fashionprice_add_to_order_session";
  const MODE_KEY = "fashionprice_add_to_order_mode";

  const query = new URLSearchParams(location.search);
  const incoming = query.get("fp_add_session");
  if (incoming && /^[A-Za-z0-9_-]{40,60}$/.test(incoming)) {
    sessionStorage.setItem(SESSION_KEY, incoming);
    sessionStorage.setItem(
      MODE_KEY,
      query.get("fp_add_mode") === "reorder" ? "reorder" : "request"
    );
  }

  function selectedVariantId() {
    const checked = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]:checked'
    );
    const field =
      checked ||
      document.querySelector('form[action*="/cart/add"] select[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return field ? String(field.value || "") : "";
  }

  function init() {
    const sessionToken = sessionStorage.getItem(SESSION_KEY);
    const mode = sessionStorage.getItem(MODE_KEY) || "request";
    const widget = document.querySelector("[data-fp-add-order]");
    if (!sessionToken || !widget) return;

    widget.hidden = false;
    const variantsNode = widget.querySelector("[data-fp-product-variants]");
    const button = widget.querySelector("[data-fp-add-button]");
    const quantity = widget.querySelector("[data-fp-request-qty]");
    const status = widget.querySelector("[data-fp-add-status]");
    const heading = widget.querySelector("[data-fp-add-heading]");
    const description = widget.querySelector("[data-fp-add-description]");
    if (mode === "reorder") {
      if (heading) heading.textContent = "Add to my new order";
      if (description) {
        description.textContent =
          "Add this item to your new order list. Review it in your secure link.";
      }
      button.textContent = "ADD THIS ITEM";
    }
    let variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent || "[]");
    } catch {
      status.textContent = "Product information could not be loaded.";
      button.disabled = true;
      return;
    }

    button.addEventListener("click", async () => {
      const variantId = selectedVariantId();
      const variant = variants.find((row) => String(row.id) === variantId);
      if (!variant) {
        status.textContent = "Please select a size or colour first.";
        return;
      }
      if (!variant.available) {
        status.textContent = "This selection is currently sold out.";
        return;
      }
      const qty = Math.max(1, Math.min(20, Number(quantity.value || 1)));
      button.disabled = true;
      status.textContent =
        mode === "reorder" ? "Adding this item..." : "Sending your request...";
      try {
        const response = await fetch(`${WORKER}/api/order-item-requests`, {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify({
            session_token: sessionToken,
            variant_id: String(variant.id),
            sku: variant.sku || `VARIANT-${variant.id}`,
            variant_title: variant.title || "",
            quantity: qty,
            unit_price: Number(variant.price || 0),
            image_url: variant.image_url || null,
            product_url: widget.dataset.productUrl,
            product_title: widget.dataset.productTitle,
          }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || "Unable to send request.");
        if (data.direct_reorder) {
          status.textContent =
            "Item added. Return to your secure link to review or checkout.";
          button.textContent = "ITEM ADDED";
        } else {
          status.textContent =
            "Request sent. FashionPrice will check stock and add it to your secure order page.";
          button.textContent = "REQUEST SENT";
        }
      } catch (error) {
        status.textContent = error.message;
        button.disabled = false;
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
